// Central place for the backend API base URL.
// In production/staging this comes from the REACT_APP_API_BASE_URL
// env var (set in .env or .env.production). Falls back to localhost
// for local development when no env var is set.
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "";
